const useExcutionFile = (versionData = []) => {
  const executeFiles = new Set();

  versionData.flatMap(version => 
    version?.execute_files?.map(file => ({
      label: file.name,
      value: file.name,
    })) || []
  ).forEach(file => executeFiles.add(JSON.stringify(file)));

  return { 
    data: Array.from(executeFiles).map(file => JSON.parse(file))
  };
};

export default useExcutionFile;